// CRM-04: o tempo curto do Kanban ("3d", "5h", "20min"), com as chaves que o painel já usava para o
// tempo na etapa anterior. Serve à face ("aguardando há…") e ao painel.
export const tempoCurto = (segundos, t) => {
  const total = Math.max(0, Math.floor(segundos || 0));
  const dias = Math.floor(total / 86400);
  if (dias >= 1) return t('KANBAN.DRAWER.DAYS', { count: dias });
  const horas = Math.floor(total / 3600);
  if (horas >= 1) return t('KANBAN.DRAWER.HOURS', { count: horas });
  return t('KANBAN.DRAWER.MINUTES', {
    count: Math.max(1, Math.floor(total / 60)),
  });
};

// O servidor manda os instantes do Kanban em segundos desde a época (`to_i`).
export const segundosDesde = epoch =>
  Math.max(0, Math.floor(Date.now() / 1000) - epoch);
